function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m248 132.999c-69.52-.52-126.97 56.48-126.97 126 0 48.02 26.87 89.76 66.38 111.03 10.27 5.52 16.59 16.32 16.62 27.97v55c0 17.67 14.33 32 32 32h22c17.67 0 32-14.33 32-32 0-10.213 0-44.657 0-55 .03-11.78 6.56-22.53 16.93-28.14 39.35-21.32 66.07-62.97 66.07-110.86 0-69.27-55.89-125.48-125.03-126z",
  fill: "#ffe773"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m182.934 251.454c-8.243-3.184-12.344-12.448-9.16-20.69 7.805-20.205 23.778-36.545 43.823-44.831 8.166-3.375 17.523.508 20.899 8.674 3.375 8.167-.508 17.523-8.674 20.899-11.986 4.955-21.535 14.719-26.197 26.789-3.183 8.237-12.44 12.344-20.691 9.159z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#ffec8f"
}, /*#__PURE__*/React.createElement("path", {
  d: "m54 274.969h-38c-8.836 0-16-7.164-16-16s7.164-16 16-16h38c8.836 0 16 7.164 16 16 0 8.837-7.164 16-16 16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m72.606 434.333c-6.249-6.249-6.249-16.379 0-22.627l26.87-26.87c6.249-6.249 16.379-6.249 22.627 0 6.249 6.249 6.249 16.379 0 22.627l-26.87 26.87c-6.247 6.248-16.378 6.249-22.627 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m248.03 80.999c-8.836 0-16-7.164-16-16v-38c0-8.836 7.164-16 16-16s16 7.164 16 16v38c0 8.837-7.164 16-16 16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m99.526 133.113-26.87-26.87c-6.249-6.249-6.249-16.379 0-22.627 6.249-6.249 16.379-6.249 22.627 0l26.87 26.87c6.249 6.249 6.249 16.379 0 22.627-6.247 6.247-16.378 6.249-22.627 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m373.886 133.163c-6.249-6.248-6.249-16.379 0-22.627l26.87-26.87c6.248-6.249 16.379-6.249 22.627 0 6.249 6.248 6.249 16.379 0 22.627l-26.87 26.87c-6.247 6.248-16.379 6.249-22.627 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m480 275.029h-38c-8.836 0-16-7.164-16-16s7.164-16 16-16h38c8.836 0 16 7.164 16 16s-7.164 16-16 16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m400.707 434.383-26.87-26.87c-6.249-6.249-6.249-16.379 0-22.627 6.249-6.249 16.379-6.249 22.627 0l26.87 26.87c6.249 6.249 6.249 16.379 0 22.627-6.248 6.247-16.379 6.249-22.627 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m151.701 294.088c1.519 14.723-19.428 19.359-24.171 5.338-27.904-82.499 35.419-167.756 121.493-166.415 14.81.231 16.846 21.519 2.368 24.645-60.76 13.12-106.586 69.609-99.69 136.432z"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m306.96 369.859c-10.37 5.61-16.9 16.36-16.93 28.14v55c0 17.673-14.327 32-32 32h-22c-11.95 0-22.38-6.56-27.88-16.27 3.67 1.46 7.68 2.27 11.88 2.27h22c17.673 0 32-14.327 32-32v-55c.03-11.78 6.56-22.53 16.93-28.14 40.806-22.109 63.429-62.132 65.844-103.561.585-10.03 15.507-10.029 16.024.005 2.364 45.934-20.064 92.739-65.868 117.556z",
  fill: "#fadf5a"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m290.03 397.999v55c0 17.67-14.33 32-32 32h-22c-17.67 0-32-14.33-32-32 0-10.209 0-44.66 0-55z",
  fill: "#aaa"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m290.03 397.999v55c0 17.673-14.327 32-32 32-23.972 0-22.447.014-23.486-.034-8.962-.41-8.535-13.901.437-13.947 2.124-.011 4.459-.019 7.039-.019 17.674 0 32.01-14.324 32.01-31.997 0-12.719 0-26.134 0-34.026 0-3.856 3.126-6.976 6.982-6.976h9.018z",
  fill: "#999"
});

var SvgBulb = function SvgBulb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 496 496",
    height: 512,
    viewBox: "0 0 496 496",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBulb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bulb.e3a6d111.svg";
export { ForwardRef as ReactComponent };